import { render, staticRenderFns } from "./TaskBlocker.vue?vue&type=template&id=0e7139d6&scoped=true&"
import script from "./TaskBlocker.vue?vue&type=script&lang=js&"
export * from "./TaskBlocker.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlocker.vue?vue&type=style&index=0&id=0e7139d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7139d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
